export default __webpack_public_path__ + "static/media/V340_SOV.5adc6ce1.pdf";